import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgIconGlossaryBookmark = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	fill: "currentColor",
	viewBox: "0 0 28 38",
	...props,
	children: /* @__PURE__ */ _jsx("path", { d: "M0 .5v35.562a1.774 1.774 0 0 0 2.793 1.45L14 29.668l11.207 7.846A1.774 1.774 0 0 0 28 36.062V.5H0Z" })
});
export default SvgIconGlossaryBookmark;
